<mat-select
  [value]="scoreValue"
  (selectionChange)="handleSelection($event)"
  [placeholder]="'MEDDIC.SCORE_OPTIONS.PLACEHOLDER' | translate"
>
  <mat-option [value]="0">
    {{ 'MEDDIC.SCORE_OPTIONS.' + scoreI18nKey + '.SCORE_0' | translate }}
    - {{ 'MEDDIC.POINT_VAL_0' | translate }}
  </mat-option>
  <mat-option [value]="1">
    {{ 'MEDDIC.SCORE_OPTIONS.' + scoreI18nKey + '.SCORE_1' | translate }}
    - {{ 'MEDDIC.POINT_VAL_1' | translate }}
  </mat-option>
  <mat-option [value]="2">
    {{ 'MEDDIC.SCORE_OPTIONS.' + scoreI18nKey + '.SCORE_2' | translate }}
    - {{ 'MEDDIC.POINT_VAL_2' | translate }}
  </mat-option>
</mat-select>
